import { Box, Typography } from "@mui/material";
import React from "react";
import { SchoolLeader } from "../../types/record";
import StarIcon from "../../assets/images/star.png";
import StudentsIcon from "../../assets/images/one-student.png";
import GoldIcon from "../../assets/images/gold-medal.png";
import SilverIcon from "../../assets/images/silver-medal.png";
import BronzeIcon from "../../assets/images/bronze-medal.png";
import { SPColor } from "../../constants/color";

type LeaderBoardProps = {
  item: SchoolLeader;
  type?: string;
};

export default function LeaderBoard({ item, type }: LeaderBoardProps) {
  const getRankNum = (rank: number) => {
    if (rank === 1) {
      return (
        <img src={GoldIcon} style={{ width: "32.38px", height: "100%" }} />
      );
    }
    if (rank === 2) {
      return (
        <img src={SilverIcon} style={{ width: "32.38px", height: "100%" }} />
      );
    }
    if (rank === 3) {
      return (
        <img src={BronzeIcon} style={{ width: "32.38px", height: "100%" }} />
      );
    }
    return rank;
  };
  return (
    <Box
      display="flex"
      marginTop={2}
      sx={{
        borderRadius: "5px",
        backgroundColor: SPColor.LIGHT_BLUE,
        height: "47px",
      }}
    >
      <Box
        display="flex"
        alignItems={"center"}
        justifyContent={"center"}
        sx={{
          paddingY: 1,
          paddingX: 2,
          borderRadius: "5px",
          backgroundColor: SPColor.SYSTEM1,
        }}
        minWidth={{ md: "17%", xs: "24%" }}
      >
        <img src={StarIcon} width="30" height="30" />
        <Typography marginLeft={1} color={SPColor.WHITE} fontSize={"1.3rem"}>
          {item.stars}
        </Typography>
      </Box>
      <Box
        display="flex"
        justifyContent={"space-between"}
        sx={{
          // backgroundColor: SPColor.LIGHT_BLUE,
          borderTopRightRadius: "5px",
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: "5px",
          borderTopLeftRadius: 0,
        }}
        width="90%"
        paddingLeft={1}
        paddingRight={1}
        borderRadius="5px"
      >
        <Box
          sx={{
            border: "solid 2px " + SPColor.SYSTEM1,
            borderRadius: "5px",
            margin: "5px",
            display: { md: "flex", xs: "none" },
          }}
          alignItems={"center"}
          justifyContent={"center"}
          paddingX={2}
          // borderRadius="5px"
        >
          <Typography
            marginRight={2}
            color={SPColor.WHITE}
            sx={{ display: { md: "block", xs: "none" } }}
          >
            {item.students}
          </Typography>
          <img src={StudentsIcon} width="30" />
        </Box>
        {type === "grade" && <Box sx={{ flexGrow: 1 }}></Box>}
        <Box
          display="flex"
          // alignItems={"center"}
          justifyContent={{ xs: "flex-end", md: "space-between" }}
          // borderRadius="5px"
          width={{ md: "100%", xs: "100%" }}
        >
          {type && type === "school" ? (
            <Box
              display={{ xs: "none", md: "flex" }}
              alignItems="center"
              width="0%"
              justifyContent={"flex-end"}
            ></Box>
          ) : (
            <Box
              display={{ xs: "none", md: "flex" }}
              alignItems="center"
              width="20%"
              justifyContent={"flex-end"}
            >
              <Typography color={SPColor.WHITE}>{item.id}</Typography>
            </Box>
          )}

          <Box
            display="flex"
            justifyContent={{ xs: "flex-end", md: "space-between" }}
            paddingRight="3px"
            // paddingRight={item.place > 3 ? "10px" : "3px"}
          >
            <Typography
              color={SPColor.WHITE}
              component="h6"
              variant="h6"
              marginRight={1}
              fontSize={{ md: "1.25rem", xs: "1rem" }}
              display="flex"
              alignItems={"center"}
              sx={{ direction: "rtl" }}
              textAlign="right"
              lineHeight="1"
            >
              {item.name}
            </Typography>
            <Typography
              color={SPColor.WHITE}
              component="h5"
              variant="h5"
              display={"flex"}
              paddingY={0}
              minWidth="30px"
              // flexDirection="column"
              justifyContent={"center"}
              alignItems={item.place < 4 ? "flex-start" : "center"}
            >
              {getRankNum(item.place)}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
